export const setupWizard = {
  top: {
    title: "مساعد الإعداد",
    subtitleFallback: "الإعداد الأساسي للإعلان",
    stepCount: "الخطوة {current} من {total}",
    closeAria: "إغلاق المساعد",
    closeTitle: "إغلاق",
  },
  intro: {
    title: "لنُجهّز مكان إقامتك معًا!",
    subBefore: "سنرافقك خطوة بخطوة لتجهيز",
    yourListingFallback: "إعلانك",
    subAfter: "لاستقبال النزلاء. لا تحتاج إلى خبرة تقنية: ستنتهي من كل شيء في دقائق. 😊",
    start: "لنبدأ!",
    skip: "ليس الآن، سأفعل ذلك لاحقًا",
  },
  steps: {
    confirmation: {
      label: "تأكيد الحجز",
      desc: "نُعلم النزيل بأن حجزه مؤكد عبر واتساب والبريد الإلكتروني. عند إيقاف هذا الخيار لن يصله إشعار. وإذا حجز عبر قناة OTA، فستتولى القناة إشعاره.",
    },
    welcome: {
      label: "رسالة الترحيب",
      desc: "الرسالة التي يتلقاها النزيل فور إتمام تسجيل الوصول عبر الإنترنت، وتتضمن الترحيب وتعليمات الوصول.",
    },
    schedule: {
      label: "جدولة تسجيل الوصول",
      desc: "متى تريد أن نرسل للنزيل رابط تسجيل الوصول؟",
    },
    hours: {
      label: "وقت الوصول والمغادرة",
      desc: "في أي وقت يمكن للنزيل الوصول والمغادرة؟",
    },
    locks: {
      label: "نوع القفل",
      desc: "كيف يدخل النزيل إلى مكان إقامتك؟",
    },
    authorities: {
      label: "الربط مع السلطات",
      desc: "نرسل تقرير المسافرين إلى السلطات نيابةً عنك دون أن تفعل أي شيء.",
    },
    services: {
      label: "الخدمات",
      desc: "اضبط الخدمات ووسائل الراحة التي يوفرها مكان إقامتك.",
    },
    policies: {
      label: "السياسات",
      desc: "قواعد وشروط مكان إقامتك.",
    },
    calendar: {
      label: "جهّز تقويمك",
      desc: "سنوضّح لك كيف تجعل تقويمك جاهزًا لاستقبال الحجوزات.",
    },
  },
  nav: {
    back: "رجوع",
    next: "التالي",
    finish: "إنهاء",
  },
  preview: {
    audienceOwner: "ما تراه أنت (المضيف)",
    audienceGuest: "ما يراه النزيل",
    accommodationFallback: "مكان الإقامة",
    online: "متصل الآن",
    today: "اليوم",
    captionGuestWeb: "معاينة · صفحة النزيل",
  },
  schedule: {
    title: "متى يبدأ تسجيل الوصول؟",
    hint: "حدّد موعد إرسال الوكيل رابط تسجيل الوصول إلى النزيل. يُطبَّق على مستوى الإعلان.",
    caption: "معاينة · تسلسل تسجيل الوصول",
  },
  // رسائل المساعد على واتساب تُعرض كما هي (ثنائية اللغة ES+EN) في جميع اللغات
  // لأنها تعكس رسالة المنتج الفعلية.
  checkin: {
    propFallback: "tu alojamiento",
    greeting: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    quote: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*. Estoy aquí para ayudarte con el proceso de che…",
    subCheckin: "Vamos a hacer el check-in · Let's check-in",
    ok: "Ok",
    chooseLang: "Elige tu idioma",
    langEs: "Español",
    langEn: "English",
    thanks: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎",
  },
  confirmation: {
    toggleLabel: "هل تريد إرسال تأكيد الحجز إلى النزيل عبر واتساب؟",
    toggleHint: "بمجرد تأكيد الحجز، ستصله هذه الرسالة بكل تفاصيل إقامته، ليطمئن أن كل شيء على ما يرام. 😊",
    stateOn: "نعم، أرسلها",
    stateOff: "عدم الإرسال",
    mapAlt: "موقع مكان الإقامة",
    addressFallback: "عنوان مكان الإقامة",
    caption: "معاينة · رسالة التأكيد",
    propFallback: "مكان إقامتك",
    guestSample: "Laura García",
    body: "مرحبًا *{guest}* 👋\n\nتم تأكيد حجزك في *{name}* ✅\n\nرمز الحجز: *6233Q1VC5*\nالتواريخ: *05/06/2026* – *07/06/2026* 📅\n\nعبر واتساب هذا يمكنك طلب رابط تسجيل الوصول عبر الإنترنت، وكذلك استلام تعليمات الوصول.\nإذا احتجت المساعدة قبل إقامتك أو خلالها، راسلنا هنا 💬",
    cta: "🇸🇦 لمتابعة تسجيل الوصول، اضغط زر *Ok* أو اكتب *Ok*.",
  },
  policies: {
    guestBubble: "لمتابعة العملية يجب أن توافق على الشروط والأحكام.",
    termsTitle: 'اللوائح والقواعد · مسكن لأغراض سياحية "{name}"',
    termsBodyLabel: "أولًا.– التسجيل",
    termsBodyText: "على كل نزيل، سواء كان فردًا أو ضمن مجموعة، تعبئة استمارة تسجيل بشكل فردي أو لكل غرفة، وتُقدَّم له عند الوصول أو عبر الإنترنت.",
    accept: "أوافق على الشروط والأحكام",
  },
  guestPreview: {
    continue: "متابعة",
  },
  authorities: {
    ofTotal: "من {total}",
    heading: "المعلومات المطلوبة بموجب المرسوم الملكي 933/2021 الصادر عن حكومة إسبانيا",
    intro: "بموجب المرسوم الملكي 933/2021، الساري اعتبارًا من 2 ديسمبر 2024، نحتاج إلى جمع البيانات التالية للامتثال للوائح الأمنية.",
    countryLabel: "بلد الإقامة",
    sampleCountry: "🇪🇸 إسبانيا",
    cityLabel: "مدينة الإقامة",
    sampleCity: "مالقة",
    addressLabel: "عنوان الإقامة",
    sampleAddress: "شارع لاريوس 77",
    postalLabel: "الرمز البريدي للإقامة",
  },
  locks: {
    embedEmpty: "أضِف وحدة إلى الإعلان أولًا لضبط الأقفال والدخول.",
  },
  calendar: {
    iframeTitle: "جهّز تقويمك",
    videoSoon: "سيتوفر الفيديو هنا قريبًا جدًا.",
    hint: "شغّل الفيديو واتبع الخطوات: خلال لحظات سيصبح تقويمك جاهزًا لاستقبال الحجوزات. 🎬",
  },
};
